import React, { useEffect, useMemo } from "react";
import { useState } from "react";
import styled from "styled-components";
import { components } from "react-select";
import { useHistory } from "react-router-dom";
import { ReactComponent as RemoveRecoIcon } from "../../../assets/FollowUpDeleteIcon.svg";
import { ReactComponent as RemoveRecoIconHover } from "../../../assets/delete-hover.svg";
import { makeStyles } from "@material-ui/core/styles";
import { useDispatch } from "react-redux";
import Creatable from "react-select/creatable";
import { useSelector } from "react-redux";
import { Spinner } from "react-bootstrap";
import { getAllExamCodes, getAllModalities } from "../../../actions/radminUploads";

import { BackNavigateIcon } from "../Cohorts/Icons";
import { UpdateComputedReport } from "../../../actions/radminSettings";

const Container = styled.div`
  border: 1px solid #dfe0eb;
  border-radius: 8px;
  background: white;
  width: 717px;
  padding: 30px;
`;

const CheckBoxLabel = styled.label`
  display: flex;
  gap: 10px;
  align-items: center;
  margin-top: 15px;
`;

const CheckboxTitle = styled.span`
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  color: #6d6e6e;
  text-align: left;
  text-transform: uppercase;
`;

const IconContainer = styled.span`
  position: relative;
  cursor: pointer;
  display: inline-block;
  width: 30px;
  height: 20px;

  &:hover svg:not(.light) {
    display: none;
  }

  &:hover svg.light {
    display: block;
  }

  svg {
    position: absolute;
    top: 0;
    left: 0;
  }

  svg.light {
    display: none;
  }
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
`;

const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Label = styled.label`
  align-self: flex-start;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  color: #3f4857;
`;

const Remove = styled.div`
  cursor: pointer;
  margin-top: 30px;
`;

const Input = styled.input.attrs({ type: "text" })`
  width: ${({ isChecked }) => (isChecked ? `10%` : `100%`)};
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #c2ccd9;
  font-family: Roboto Condensed;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  color: #333333;
  height: 38px;
`;

const SwitchContainer = styled.div`
  display: flex;
  background: #e6e9f1;
  border-radius: 8px;
  font-family: Roboto Condensed;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  color: #0c2945;
  width: fit-content;
  margin-top: 10px;
  margin-bottom: 20px;
`;

const SwitchButton = styled.button`
  padding: 7px 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => (props.active ? "#0C2945" : "#E6E9F1")};
  color: ${(props) => (props.active ? "#F9FAFC" : "#0C2945")};
  font-weight: ${(props) => (props.active ? 700 : 600)};
  border: 0;
  outline: 0;
  border-radius: 6px;
`;

const Button = styled.button`
  width: 140px;
  height: 38px;
  background: ${({ isPrimary, disabled }) =>
    disabled ? "#00AEEF4D" : isPrimary ? "#00AEEF" : "transparent"};
  border-radius: 5px;
  border: ${({ isPrimary, disabled, color }) =>
    disabled
      ? "2px solid transparent"
      : isPrimary
      ? "2px solid #00AEEF"
      : `2px solid ${color ? color : "#CFCFCF"}`};
  outline: none !important;
  font-family: Roboto Condensed;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  color: ${({ isPrimary, color }) =>
    isPrimary ? "white" : color ?? "#000000"};
  &:hover {
    background: ${({ isPrimary, color }) =>
      isPrimary ? "transparent" : color ?? "#CFCFCF"};
    color: ${({ isPrimary }) => (isPrimary ? "#00aeef" : "white")};
    border: ${({ isPrimary, disabled, color }) =>
      isPrimary
        ? "2px solid #00AEEF"
        : `2px solid ${color ? color : "#CFCFCF"}`};
  }
`;

const IndicatorsContainer = (props) => {
  return (
    <div style={{ backgroundColor: "#FFF" }}>
      <components.IndicatorsContainer {...props} />
    </div>
  );
};

const RadioOption = (props) => {
  return (
    <>
      <components.Option {...props}>
        <div style={{ display: "flex", gap: "5px" }}>
          <span>
            <input
              type="radio"
              checked={props.isSelected}
              onChange={() => null}
              style={{ marginTop: 5 }}
            />{" "}
          </span>
          <label>{props.label}</label>
        </div>
      </components.Option>
    </>
  );
};

const statusList = [
  { label: "Not Compliant", value: "not_compliant" },
  { label: "Completed", value: "completed" },
  { label: "Scheduled", value: "scheduled" },
  { label: "Ordered", value: "ordered" },
  { label: "Not Completed", value: "not_completed" },
];

const tabOption = [
  { label: "Modality", value: "modality" },
  { label: "Exam Code", value: "exam_code" },
];


const EditReportSetting = (props) => {
  const transformToSelectFormat = (modalityMappings, name) => {
    if(name === 'modality') {
     return  modalityMappings.map((item, index) => ({
      id: index + 1,
      report2_modality: item.report2_modality
        ? { label: item.report2_modality, value: item.report2_modality }
        : null,
      subsequent_modality: item.subsequent_modality
        ? { label: item.subsequent_modality, value: item.subsequent_modality }
        : null,
    }))
    }
    if(name === 'exam_code') {
    return  modalityMappings?.map((item, index) => ({
      id: index + 1,
      report2_exam_code: item?.report2_exam_code
        ? { label: item?.report2_exam_code, value: item?.report2_exam_code }
        : null,
      subsequent_exam_code: item?.subsequent_exam_code
        ? { label: item?.subsequent_exam_code, value: item?.subsequent_exam_code }
        : null,
    })) || [{
      id: Date.now(),
    }]

    }
    };
  const { dialogHandler, data: reportListData, onClickBackButton } = props;

  const history = useHistory();
  const dispatch = useDispatch();
  const query = new URLSearchParams(history.location.search);
  const [loading, setLoading] = useState(false);
  const [modalitiesData, setModalitiesData] = useState();
  const [examCodeData, setExamCodeData] = useState();
  const [reportData, setReportData] = useState({
    name: reportListData?.name || "",
    days: reportListData?.days || "",
    computed_status: reportListData?.computed_status_filter || [],
    modality: transformToSelectFormat(reportListData?.modality_mappings || [], 'modality'),
    exam_code: transformToSelectFormat(reportListData?.exam_code_mappings || [], 'exam_code'),
    id: reportListData?.id || "",
    title: reportListData?.name || "",
  });
  const [fields, setFields] = useState([
    {
      id: Date.now(),
    },
  ]);
  const [examFields, setExamFields] = useState([
    {
      id: Date.now(),
    },
  ]);
    const [activeTab, setActiveTab] = useState("modality");


  const computedReportsData = useSelector(
    (state) => state.radAdmin.computedReports
  );

  let id = query.get("id");
  let action = query.get("action");
  const url = new URL(window.location.href);

  const modalitiesFilter = Array.isArray(fields)
  ? fields
      .filter(item =>
        item?.report2_modality?.value !== undefined &&
        item?.report2_modality?.value !== null &&
        item?.report2_modality?.value !== '' &&
        item?.subsequent_modality?.value !== undefined &&
        item?.subsequent_modality?.value !== null &&
        item?.subsequent_modality?.value !== ''
      ).map((item) => ({ "report2_modality": item?.report2_modality?.value, "subsequent_modality": item?.subsequent_modality?.value }))
  : [];


  const examCodeFilter = examFields?.map((item) => ({
    report2_exam_code: item?.report2_exam_code?.value,
    subsequent_exam_code: item?.subsequent_exam_code?.value,
  }));

  const validExamCodeFilter = Array.isArray(examFields)
  ? examFields
      .filter(item =>
        item?.report2_exam_code?.value !== undefined &&
        item?.report2_exam_code?.value !== null &&
        item?.report2_exam_code?.value !== '' &&
        item?.subsequent_exam_code?.value !== undefined &&
        item?.subsequent_exam_code?.value !== null &&
        item?.subsequent_exam_code?.value !== ''
      )
      .map(item => ({
        report2_exam_code: item.report2_exam_code.value,
        subsequent_exam_code: item.subsequent_exam_code.value
      }))
  : [];

  useEffect(() => {
    if (id) {
      const matchingReport = computedReportsData?.data?.find(
        (data) => data?.id == id
      );
      if (matchingReport) {
        setReportData((prev) => ({
          ...prev,
          name: matchingReport.name || "",
          days: matchingReport.days || "",
          computed_status: matchingReport.computed_status_filter || [],
          id: matchingReport.id,
          title: matchingReport?.name || "",
        }));
        setFields(transformToSelectFormat(matchingReport?.modality_mappings, 'modality'));
        setExamFields(transformToSelectFormat(matchingReport?.exam_code_mappings, 'exam_code'));
        url.searchParams.set("id", id || matchingReport?.id);
        window.history.pushState({}, "", url.toString());
        setActiveTab(matchingReport?.modality_mappings && matchingReport?.modality_mappings?.length > 0 ? 'modality' : (matchingReport?.exam_code_mappings && matchingReport?.exam_code_mappings?.length > 0 ? 'exam_code' : 'modality'))

      }
    }
    if (action) {
      url.searchParams.set("action", "create");
      window.history.pushState({}, "", url.toString());
    }
  }, [computedReportsData?.data]);

  const handleAddMore = () => {
    setFields([...fields, { id: Date.now() }]);
  };

  const handleAddMoreExamCode = () => {
    setExamFields([...examFields, { id: Date.now() }]);
  };

  const handleRemove = (id) => {
    setFields(fields.filter((f) => f.id !== id));
  };

  const handleRemoveExamCode = (id) => {
    setExamFields(examFields.filter((f) => f.id !== id));
  };

  useEffect(() => {
    dispatch(getAllModalities()).then((res) => {
      if (res) {
        setModalitiesData(
          res
            ?.filter((itm) => itm.modality !== "")
            .map((itm) => ({ label: itm.modality, value: itm.modality }))
        );
      }
    });
    dispatch(getAllExamCodes()).then((res) => {
      if (res) {
        setExamCodeData(
          res?.filter((itm) => itm.exam_code !== "")
            .map((itm) => ({ label: itm.exam_code, value: itm.exam_code }))
        );
      }
    });
  }, []);

  const handleSave = async () => {
    setLoading(true);
    const payload = {
      name: reportData?.name,
      computed_status_filter: reportData?.computed_status,
      days: reportData?.days,
      modality_mappings:
      activeTab === "modality" && modalitiesFilter && modalitiesFilter.length > 0
        ? modalitiesFilter
        : [],
      exam_code_mappings:
      activeTab === "exam_code" && validExamCodeFilter && validExamCodeFilter.length > 0
        ? validExamCodeFilter
        : [],
    };
    if ((reportData?.id, payload)) {
      await dispatch(UpdateComputedReport(reportData?.id, payload)).then(
        (res) => {
          onClickBackButton();
        }
      );
    }


    setLoading(false);
  };

  const handleChange = (id, type, selectedOption) => {
    setFields((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, [type]: selectedOption } : item
      )
    );
  };

  const handleChangeExamCode = (id, type, selectedOption) => {
    setExamFields((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, [type]: selectedOption } : item
      )
    );
  };

  const handleOptionChange = (event) => {
    const value = event.target.value;
    if (reportData?.computed_status.includes(value)) {
      setReportData((prev) => ({
        ...prev,
        computed_status: reportData?.computed_status?.filter(
          (item) => item !== value
        ),
      }));
    } else {
      setReportData((prev) => ({
        ...prev,
        computed_status: [...reportData?.computed_status, value],
      }));
    }
  };

  const isButtonDisabled = useMemo(() => {
    const allHaveInitialModality = fields?.every(
      (item) =>
        item?.report2_modality &&
        item?.subsequent_modality &&
        typeof item.report2_modality === "object" &&
        typeof item.subsequent_modality === "object" &&
        Object.keys(item.report2_modality).length > 0 &&
        Object.keys(item.subsequent_modality).length > 0
    );

     const allHaveInitialExamCode = examFields?.every((item) =>
      item?.report2_exam_code &&
      item?.subsequent_exam_code &&
      typeof item.report2_exam_code === 'object' &&
      typeof item.subsequent_exam_code === 'object' &&
      Object.keys(item.report2_exam_code).length > 0 &&
      Object.keys(item.subsequent_exam_code).length > 0
    );

    if (reportData?.days && activeTab === 'modality' && allHaveInitialModality) {
      return false;
    }
    if (reportData?.days && activeTab === 'exam_code' && allHaveInitialExamCode) {
      return false;
    }
    return true;
  }, [reportData?.days, fields, examFields, activeTab]);

  return (
    <>
      {computedReportsData?.isLoading && !reportData?.id ? (
        <LoadingContainer>
          <Spinner animation="border" role="status" />
        </LoadingContainer>
      ) : (
        <Row>
          <Container>
            <div style={{ display: "flex", gap: "16px" }}>
              <span
                onClick={() => onClickBackButton()}
                style={{ cursor: "pointer" }}
              >
                <BackNavigateIcon />
              </span>
              <h4
                style={{
                  fontSize: "24px",
                  fontWeight: "bold",
                  marginBottom: "18px",
                }}
              >
                {action ? `Create` : `${reportData?.title}`} Cohort Detail
              </h4>
            </div>
            <div>
              <div>
                <Label children={"Saved Search Name"} htmlFor="filterSet" />
                <br />
                <Input
                  type="text"
                  onChange={(e) => {
                    const inputValue = e.target.value;
                    setReportData((prev) => ({
                      ...prev,
                      name: inputValue,
                    }));
                  }}
                  style={{ color: "#000000" }}
                  value={reportData?.name}
                  id="filterSet"
                  placeholder={"Enter Name"}
                />
              </div>
              <div style={{ marginTop: "36px" }}>
                {statusList?.map((status) => (
                  <CheckBoxLabel key={status.value}>
                    <input
                      type="checkbox"
                      value={status.value}
                      style={{ height: "20px", width: "20px" }}
                      checked={reportData?.computed_status.includes(
                        status.value
                      )}
                      onChange={handleOptionChange}
                    />
                    <span className="custom-checkbox" />
                    <CheckboxTitle>{status.label}</CheckboxTitle>
                  </CheckBoxLabel>
                ))}
              </div>

              <div>
                <Label
                  children={"DAYS UNTIL SUBSEQUENT REPORT(<= 450)*"}
                  htmlFor="filterSet"
                />
                <br />
                <Input
                  min={0}
                  type="number"
                  max={450}
                  style={{ width: "50px", color: "#000000", marginBottom: '20px' }}

                  onChange={(e) => {
                    const input = e.target.value;
                    if (!/^\d*$/.test(input)) {
                      setReportData((prev) => ({
                        ...prev,
                        days: "",
                      }));
                    }

                    if (input >= 0 && input <= 450) {
                      setReportData((prev) => ({
                        ...prev,
                        days: input,
                      }));
                    } else if (input === "") {
                      setReportData((prev) => ({
                        ...prev,
                        days: "",
                      }));
                    }
                  }}
                  value={reportData?.days}
                  id="filterSet"
                  placeholder={""}
                />
              </div>
              <Label children={"Select Either Modality or Exam Code to add mappings"} htmlFor="filterSet" />
              <SwitchContainer>
        {tabOption.map((tab) => (
          <SwitchButton
          type="button"
            active={activeTab === tab.value}
            onClick={() => {
              setActiveTab(tab.value);
              if(tab.value === 'exam_code' && (!examFields[0]?.report2_exam_code || !examFields[0]?.subsequent_exam_code) ) {
              setExamFields([{ id: Date.now() }]);
              }
              if(tab.value === 'modality' && (!fields[0]?.report2_modality || !fields[0]?.subsequent_modality)) {
              setFields([{ id: Date.now() }]);
              }
            }}
          >
            {tab.label}
          </SwitchButton>
        ))}
            </SwitchContainer>
            {
              activeTab === 'modality' ? (
                 <div style={{padding: '20px 0px', margin: '8px 0px'}}>
                <h6
                style={{
                  fontWeight: "bold",
                  marginBottom: "18px",
                }}
              >MODALITY MAPPING</h6>
              <div>
                {fields?.map((field, index) => (
                  <div
                    key={field.id}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      gap: "10px",
                      alignItems: "center",
                      marginTop: "5px",
                      marginBottom: "1rem",

                    }}
                  >
                    <div style={{ minWidth: "220px" }}>
                      <Label children="INITIAL MODALITY*" />
                      <Creatable
                        isClearable={true}
                        onChange={(val) =>
                          handleChange(field.id, "report2_modality", val)
                        }
                        options={modalitiesData}
                        value={field.report2_modality}
                        placeholder="Select..."
                        components={{
                          IndicatorsContainer,
                          Option: RadioOption,
                        }}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        styles={{
                          option: (styles) => ({
                            ...styles,
                            fontSize: "14px",
                          }),
                        }}
                      />
                    </div>

                    <div style={{ minWidth: "220px" }}>
                      <Label children="SUBSEQUENT MODALITY*" />
                      <Creatable
                        isClearable={true}
                        options={modalitiesData}
                        onChange={(val) =>
                          handleChange(field.id, "subsequent_modality", val)
                        }
                        value={field.subsequent_modality}
                        placeholder="Select..."
                        components={{
                          IndicatorsContainer,
                          Option: RadioOption,
                        }}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        styles={{
                          option: (styles) => ({
                            ...styles,
                            fontSize: "14px",
                          }),
                        }}
                      />
                    </div>
                    {fields.length !== 1 && (
                      <Remove onClick={() => handleRemove(field.id)}>
                        <IconContainer>
                          <RemoveRecoIcon />
                          <RemoveRecoIconHover className="light" />
                        </IconContainer>
                      </Remove>
                    )}
                  </div>
                ))}
              </div>
              <div style={{
                display: "flex",
                  justifyContent: "flex-end",
                  paddingRight: '67px'

              }}>
                <Button
                  type="button"
                  onClick={handleAddMore}
                  color="#00AEEF"
                  children="Add More"
                />
              </div>
              </div>
              ) : (
                activeTab === 'exam_code' && (

              <div style={{padding: '20px 0px', margin: '8px 0px'}}>
                <h6
                style={{
                  fontWeight: "bold",
                  marginBottom: "18px",
                }}
              >EXAM CODE MAPPING</h6>
              <div>
                {examFields?.map((examField, index) => (
                  <div
                    key={examField.id}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      gap: "10px",
                      alignItems: "center",
                      marginTop: "5px",
                      marginBottom: "1rem",
                    }}
                  >
                    <div style={{ minWidth: "220px" }}>
                      <Label children="INITIAL EXAM CODE*" />
                      <Creatable
                        isClearable={true}
                        onChange={(val) =>
                          handleChangeExamCode(examField.id, "report2_exam_code", val)
                        }
                        options={examCodeData}
                        value={examField.report2_exam_code}
                        placeholder="Select..."
                        components={{
                          IndicatorsContainer,
                          Option: RadioOption,
                        }}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        styles={{
                          option: (styles) => ({
                            ...styles,
                            fontSize: "14px",
                          }),
                        }}
                      />
                    </div>

                    <div style={{ minWidth: "220px" }}>
                      <Label children="SUBSEQUENT EXAM CODE*" />
                      <Creatable
                        isClearable={true}
                        options={examCodeData}
                        onChange={(val) =>
                          handleChangeExamCode(examField.id, "subsequent_exam_code", val)
                        }
                        value={examField.subsequent_exam_code}
                        placeholder="Select..."
                        components={{
                          IndicatorsContainer,
                          Option: RadioOption,
                        }}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        styles={{
                          option: (styles) => ({
                            ...styles,
                            fontSize: "14px",
                          }),
                        }}
                      />
                    </div>
                    {examFields.length !== 1 && (
                      <Remove onClick={() => handleRemoveExamCode(examField.id)}>

                        <IconContainer>
                          <RemoveRecoIcon />
                          <RemoveRecoIconHover className="light" />
                        </IconContainer>
                      </Remove>
                    )}
                  </div>
                ))}
              </div>
              <div style={{
                display: "flex",
                  justifyContent: "flex-end",
                  paddingRight: '67px'

              }}>
                <Button
                  type="button"
                  onClick={handleAddMoreExamCode}
                  color="#00AEEF"
                  children="Add More"
                />
              </div>
              </div>)
              )
            }


              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  gap: "37px",
                }}
              >
                <Button
                  type="submit"
                  isPrimary={true}
                  onClick={() => handleSave()}
                  disabled={isButtonDisabled}
                  children={
                    loading ? (
                      <Spinner animation="border" role="status" size="sm" />
                    ) : (
                      "Save Changes"
                    )
                  }
                />
                {!action && id && (
                  <div style={{ marginBottom: "34px" }}>
                    <Remove onClick={() => dialogHandler(reportData)}>
                      <IconContainer>
                        <RemoveRecoIcon />
                        <RemoveRecoIconHover className="light" />
                      </IconContainer>
                    </Remove>
                  </div>
                )}
              </div>
            </div>
          </Container>
        </Row>
      )}
    </>
  );
};

export default EditReportSetting;
